import { Button } from 'components/_form';

export const IconButton = ({ ...props }) => (
  <Button minWidth="50px" minHeight="50px" bordered transparent {...props} />
);
